import type {Size2D} from './Size2D';
import type {ScreenOrientation} from './ScreenOrientation';

export type ResizeEventData = Size2D & {
    orientation: ScreenOrientation;
    forceUpdate: boolean;
};